import React from 'react'

export default function Disc({ className }) {
  return (
    <svg viewBox="0 0 20 20" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M10.003 19.994c-5.521 0-9.997-4.476-9.997-9.997S4.482 0 10.003 0 20 4.476 20 9.997s-4.476 9.997-9.997 9.997zM3.73 8.255a.5.5 0 00.641-.299A5.98 5.98 0 016.45 5.175a.5.5 0 10-.594-.804 6.965 6.965 0 00-2.425 3.244.5.5 0 00.299.64zM6.966 2.33a.501.501 0 00-.666-.241 8.691 8.691 0 00-4.779 5.835.501.501 0 00.972.237 7.796 7.796 0 014.232-5.166.5.5 0 00.241-.665zm3.037 3.817a3.85 3.85 0 100 7.7 3.85 3.85 0 000-7.7zm8.193 4.778a.5.5 0 00-.578.407 7.738 7.738 0 01-5.642 6.14.5.5 0 00.255.968 8.743 8.743 0 006.372-6.937.5.5 0 00-.407-.578zm-8.193.1a1.028 1.028 0 110-2.055 1.028 1.028 0 010 2.055z"
      />
    </svg>
  )
}
